import { set, subMonths } from "date-fns";
import { IDateRange } from "../../utils/interfaces/DateRangeInterface";
import { IFilterListWithoutPagination } from "../../utils/interfaces/FilterListInterface";
import { toQueryString } from "../../utils/parsers/QueryString";

export class SellerComissionListFilterFormModel implements IFilterListWithoutPagination {
    partnerSellerName: string = ''
    date: IDateRange = {
        start: set(new Date(), {year: new Date().getFullYear(), month: new Date().getMonth(), date: 1}),
        end: set(new Date(), {year: new Date().getFullYear(), month: new Date().getMonth()+1, date: 0}),
    }

    isFilterFilled():boolean {
        return !!this.date && !!this.date.start && !!this.date.end
    }

    toQueryString():string {
        const tmp = {
            ...this,
            date: undefined,
            dateStart: this.date?.start?.toISOString() ?? undefined,
            dateEnd: this.date?.end?.toISOString() ?? undefined,
        }

        return toQueryString(tmp)
    }
}
